import React, { FC } from "react";
import {
  ApplicationStatus,
  ApplicationStatusText,
  IApplicationStatusProps,
} from "../../types";
import makeStyles from "@material-ui/core/styles/makeStyles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    width: 186,
  },
  dot: {
    width: 12,
    height: 12,
    borderRadius: "50%",
  },
  [ApplicationStatus.REJECTED]: {
    backgroundColor: theme.palette.error.main,
  },
  [ApplicationStatus.APPROVED]: {
    backgroundColor: theme.palette.success.main,
  },
  [ApplicationStatus.PENDING]: {
    backgroundColor: theme.palette.warning.main,
  },
  applicationLabel: {
    fontSize: 12,
    fontWeight: 500,
    color: "#231F20",
    marginLeft: 6,
    marginTop: 3,
  },
  applicationStatus: {
    fontSize: 12,
    color: "#858997",
    marginLeft: 4,
    marginTop: 3,
  },
}));

export const ApplicationStatusInfo: FC<IApplicationStatusProps> = ({
  status,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={clsx(classes.dot, classes[status.type])} />
      <div className={classes.applicationLabel}>Application Status</div>
      <div className={classes.applicationStatus}>
        - {ApplicationStatusText[status.type]}
      </div>
    </div>
  );
};
